import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent } from '@material-ui/core'
import { useIntl } from 'react-intl'
import clsx from 'clsx'
import useSelectGroup from 'app/main/subscribersV4/useSelectGroup'
import GroupSelectorContent from './components/GroupSelectorContent'
import SelectGroupDialogHeader from './components/SelectGroupDialogHeader'
import SelectGroupDialogFooter from './components/SelectGroupDialogFooter'

const PAGE_LIMIT = 20

const SelectGroup = (props) => {
  const { open, value, onConfirm, onCloseDialog, isSubmitting } = props
  const { formatMessage } = useIntl()
  const {
    state: { groups, selectedTags, isLoading, meta, isLoadmore },
    onFetchGroups,
    onDefaultValue,
    setSelectedTags,
    handleParentCheckboxChange,
    handleTagCheckboxChange,
    loadMore,
    onSearchChange,
    clearState,
    checkAllByGroup,
  } = useSelectGroup()

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm({ selectedTags })
    }
  }

  useEffect(() => {
    if (open) {
      onFetchGroups({
        groups,
        page: meta.currentPage,
        limit: PAGE_LIMIT,
        search: '',
      })
      onDefaultValue(value)
    } else {
      clearState()
    }
  }, [open, onFetchGroups])

  return (
    <div>
      <Dialog
        open={open}
        onClose={onCloseDialog}
        fullWidth
        maxWidth="sm"
        classes={{
          paper: clsx('w-screen h-screen', 'flex flex-col'),
        }}
      >
        <SelectGroupDialogHeader
          titleLocaleKey="subscriberCrm.editGroup.title"
          onCloseDialog={onCloseDialog}
          className="p-5 px-10"
        />
        <DialogContent className="flex flex-col flex-1 overflow-hidden px-10 py-5">
          <GroupSelectorContent
            groups={groups}
            selectedTags={selectedTags}
            isLoading={isLoading}
            meta={meta}
            isLoadmore={isLoadmore}
            onSearchChange={onSearchChange}
            handleParentCheckboxChange={handleParentCheckboxChange}
            handleTagCheckboxChange={handleTagCheckboxChange}
            checkAllByGroup={checkAllByGroup}
            loadMore={loadMore}
            setSelectedTags={setSelectedTags}
          />
        </DialogContent>
        <SelectGroupDialogFooter
          isSubmitting={isSubmitting}
          confirmButtonTextLocaleKey="subscriberCrm.editGroup.save.label"
          closeButtonClassName="w-128"
          useDialogActions={true}
          onCloseDialog={onCloseDialog}
          onConfirm={handleConfirm}
        />
      </Dialog>
    </div>
  )
}

SelectGroup.propTypes = {
  open: PropTypes.bool.isRequired,
  value: PropTypes.array,
  onConfirm: PropTypes.func.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
}

export default SelectGroup
